module.exports = __webpack_public_path__ + "img/tawk.626e4192.svg";